import CustomerDetailsPage from "./CustomerDetailsPage";
export default CustomerDetailsPage;
